import { ISysOptionsDTO } from "../../../../../../libs/coreapi-dto/service/sysOptions"

export interface IContractorsEditModalProps {
    data: ISysOptionsDTO
    setData: (value: ISysOptionsDTO) => void
    initForContractors?: ISysOptionsDTO
    lockFromPermission?: boolean
    isEnabled?: boolean
    contractorsError?: string
    fieldSource: FieldsSource
}

export enum FieldsSource {
    Suppliers = "Suppliers",
    Receivers = "Receivers",
}